const loadMorePosts = (args, id, btn) => {
	const data = new FormData();
	const json = JSON.parse(args);
	const btnArgs = btn;
	const container = document.querySelector(`[data-load-more-container="${id}"]`);
	const eventEnd = new Event('loadMoreEnd');

	data.append('args', args);
	data.append('action', json.action);

	const xhr = new XMLHttpRequest();

	xhr.responseType = 'text';
	xhr.onreadystatechange = () => {
		let remove = false;
		btnArgs.classList.toggle('active');

		if (xhr.readyState === 4 && xhr.status === 200) {
			const response = JSON.parse(xhr.responseText);
			if (response.success) {
				json.paged += 1;
				btnArgs.dataset.loadMoreArgs = JSON.stringify(json);
				container.innerHTML += response.data.html;
				if (response.data.btn) {
					remove = true;
				}
			} else {
				remove = true;
			}
		}

		if (remove) {
			btn.remove();
		}

		document.dispatchEvent(eventEnd);
	};

	/* global loadMorePostsVars */
	xhr.open('POST', loadMorePostsVars.ajaxUrl, true);
	xhr.send(data);
};

const init = () => {
	const btns = document.querySelectorAll('[data-load-more-btn]');
	if (!btns) return;

	btns.forEach((el) => {
		const btn = el;
		btn.onclick = (e) => {
			e.preventDefault();
			const { loadMoreArgs, loadMoreContainer } = btn.dataset;
			if (loadMoreArgs) {
				loadMorePosts(loadMoreArgs, loadMoreContainer, btn);
			}
		};
	});
};

document.addEventListener('DOMContentLoaded', () => {
	init();
});
